<template>
  <v-dialog
    v-model="display"
    persistent
    transition="dialog-bottom-transition"
    scrollable
    content-class="v-dialog-form-bottom"
  >
    <v-card flat style="100%">
      <v-card-title
        class="py-3 mb-6 justify-space-between"
        style="border-bottom: 1px solid #D3D2D2"
      >
        <div style="width:28px"></div>
        <span class="font-weight-bold">{{ selectedTemplate.title }}</span>
        <v-btn
          icon
          small
          @click="display = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text
        class="ma-0 pa-1"
      >
        <v-form>
          <v-textarea
            v-model="comment"
            rows="10"
          ></v-textarea>
        </v-form>
        <v-card-actions
          class="py-0"
        >
          <v-container class="mt-0">
            <v-row justify="end" class="px-3 mb-12">
              <v-btn
                dark
                color="#FF8040"
                elevation="0"
                class="text-capitalize"
                @click="howTo.display = true"
              >
                Tips✏️
              </v-btn>
              <v-btn
                dark
                color="#FF8040"
                elevation="0"
                class="text-capitalize"
                @click="example.display = true"
              >
                Templates📄
              </v-btn>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-btn
                  dark
                  block
                  color="#FF5500"
                  elevation="0"
                  class="text-capitalize mt-12 font-weight-bold"
                  style="border-radius: 8px"
                  @click="endEdit"
                >
                  Done
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card-text>
    </v-card>
    <!-- how to dialog -->
    <v-dialog
      v-model="howTo.display"
      v-if="howTo.display"
      persistent
      transition="dialog-right-transition"
      scrollable
      hide-overlay
      content-class="v-dialog-form-bottom"
    >
      <v-card flat>
        <v-card-title
          class="py-3 mb-0 justify-center"
          style="border-bottom: 1px solid #D3D2D2"
        >
          <span class="font-weight-bold">{{ selectedTemplate.howToTitle }}</span>
        </v-card-title>
        <v-card-text
          class="ma-0 pa-4"
          v-html="selectedTemplate.howToDescription">
        </v-card-text>
        <v-card-action class="px-4 pb-12">
          <v-btn
            dark
            block
            color="#FF5500"
            elevation="0"
            class="font-weight-bold"
            style="border-radius: 8px"
            @click="howTo.display = false"
            >OK</v-btn>
        </v-card-action>
      </v-card>
    </v-dialog>
    <!-- example dialog -->
    <v-dialog
      v-model="example.display"
      v-if="example.display"
      persistent
      scrollable
      hide-overlay
      transition="dialog-right-transition"
      content-class="v-dialog-form-bottom"
    >
      <v-card flat>
        <v-card-title
          class="py-3 mb-0 justify-space-between"
          style="border-bottom: 1px solid #D3D2D2"
        >
          <v-btn
            icon
            small
            @click="example.display = false"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <span class="font-weight-bold">{{ selectedTemplate.exampleTitle }}</span>
          <div style="width:28px"></div>
        </v-card-title>
        <v-card-text
          class="ma-0 pa-0">
          <v-list class="py-0">
            <template
              v-for="(item, index) in selectedTemplate.examples"
            >
              <v-list-item
                :key="`i-${index}`"
                three-line
                @click="selectExample(index)"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="item.title"></v-list-item-title>
                  <v-list-item-subtitle v-html="item.description"></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                :key="`d-${index}`"
              ></v-divider>
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- example selected dialog -->
    <v-dialog
      v-model="selected.display"
      v-if="selected.display"
      persistent
      scrollable
      hide-overlay
      transition="dialog-right-transition"
      content-class="v-dialog-form-bottom"
    >
      <v-card flat>
        <v-card-title
          class="py-3 mb-0 justify-space-between"
          style="border-bottom: 1px solid #D3D2D2"
        >
          <v-btn
            icon
            small
            @click="selected.display = false"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <span class="font-weight-bold">{{ selected.title }}</span>
          <div style="width:28px"></div>
        </v-card-title>
        <v-card-text class="ma-0 pa-4" v-html="selected.description">
        </v-card-text>
        <v-card-actions
          class="pa-4"
        >
          <v-row>
            <v-col cols="12">
              <v-btn
                dark
                block
                color="#FF5500"
                elevation="0"
                class="text-capitalize font-weight-bold"
                style="border-radius: 8px"
                @click="useExample('add')"
              >
                Put below your text
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn
                dark
                block
                color="#FF5500"
                elevation="0"
                class="text-capitalize font-weight-bold"
                style="border-radius: 8px"
                @click="useExample('override')"
              >
                Overwrite your text
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
// import service from '@/plugins/service'

export default {
  props: {
    value: { type: String, required: true, },
  },
  data: () => ({
    display: false,
    title: '',
    comment: '',
    howTo: {
      display: false,
    },
    example: {
      display: false,
      list: [],
    },
    selected: {
      display: false,
      title: '',
      description: '',
    },
    selectedTemplate: {},
    commentTemplates: {
      'aboutMe': {
        title: 'About me',
        howToTitle: 'Tips',
        howToDescription: `<b>&lt;What should I write here??</b>😳&gt;<br />
What do you do? / Why do you sign up to Paike? / What do you enjoy on weekends? / What is the most amazing country you have visited ever? etc.<br />
<br />
<b>&lt;Example&gt;</b><br />
I'm studying enviromental science at Tokyo university🏫. I like traveling abroad on vacation✈️🌏. The most amazing country is Thailand🇹🇭 because Thai people are always smiling and local foods were great🐟🍖🍜!<br />
I wanna make many friends from all over the world👫👫. So, that's why I'm using Paike🧡! Looking forward to seeing you guys! Please say hello to me😊
        `,
        exampleTitle: 'Templates📄',
        examples: [
          {
            title: '1) Student',
            description:
`Hello!<br />
I'm studying ●● at ●● university🏫in ●●. I like ●● on weekends. I'm planing to travel to ●● after this semster✈️🌏.<br />
I wanna make many friends from all over the world🧡<br />
Looking forward to seeing you guys! Please don't hesitate to message me😊
`,
          },
          {
            title: '2) Worker',
            description:
`Hello!<br />
I'm working as a ●●🏢 in ●●. I like ●● on weekends. I'm planing to travel to ●● on the next vacation✈️🌏.<br />
I wanna make many friends from all over the world🧡<br />
Looking forward to seeing you guys! Please don't hesitate to say hello to me😊
`,
          },
          {
            title: '3) Planning to travel',
            description:
`Hello!<br />
I'm planing to travel to ●● from month/day/year to month/day/year ✈️🌏.<br />
I wanna make many local friends 🧡<br />
Looking forward to paiking out together! Please don't hesitate to say hello to me😊
`,
          },
          {
            title: '4) Both Travel and Local',
            description:
`Hello!<br />
I am based in ●●, and I love ●●! If you want to have a local experience of  ●●,  let's paike out!<br />
Also I'm planning a trip to ●● from month/day/year to month/day/year ✈️🌏, so if anyone local there would love to paike out with you!<br />
Feel free to send messages🙂
`,
          },
          {
            title: '5) Traveler',
            description:
`Hello!<br />
I'm travelling around ●● from month/day/year to month/day/year ✈️🌏.<br />
I love meeting new people and make local friends there🧡<br />
Looking forward to paiking out together! Feel free to say hello to me😊
`,
          },
        ]
      },
      'likeComment': {
        title: 'About my passion',
        howToTitle: 'Tips',
        howToDescription: `<br/>
<b>&lt;What should I write here??</b>😳&gt;<br />
Why are you passionate about this? / How long have you been passionate? / Where did you take this picture? / What is your interesting episode about this? etc.<br />
<br />
<b>&lt;Example&gt;</b><br />
I've been passonate about ○○ for ○○ years because ×××××.  The pictures I uploaded are..........<br />
I wanna make many friends from all over the world👫👫. So, that's why I'm using Paike🧡! Looking forward to seeing you guys! Please say hello to me😊<br />
        `,
        exampleTitle: 'Templates📄',
        examples: [
          {
            title: '1) foods/drinks',
            description:
`I love to eat/drink ●● 🧡<br />
This photo is my favorite &lt;brand/restaurant/drink stand bar/ etc...&gt; , which name is ●●.<br />
I've been into ●● since when I was &lt; ●● years old/ ●●th grade / etc... &gt;.<br />
Usually, I enjoy ●● &lt; on weekends / on weekdays evening / once a week / twice a month / etc... &gt;.<br />
I wanna share my favorite ●● with you❣️Please say hello to me📩<br />
Let's Paike out!😊`,
          },
          {
            title: '2) sports',
            description:
`My passion shot is ●●!<br />
I love to &lt; watch/play/teach &gt; ●●, &lt; just for fun/in professional level/ etc... &gt;🧡<br />
This photo is  &lt; from the game on MM/DD/YY / my  ●● friends I play with / when I am playing/teaching ●● / etc...&gt; .<br />
I've been into ●● since when I was &lt; ●● years old/ ●●th grade &gt;.<br />
I've met this sport by &lt; being used to play/watching games as a fan/ etc...&gt;.<br />
Usally, I enjoy ●● &lt; on weekends / on weekdays evening / once a week / twice a month / etc... &gt;.<br />
I wanna share my passion toward ●● with you❣️Please say hello to me📩<br />
Let's Paike out!😊`,
          },
          {
            title: '3) movies/arts (movie / theatre play / arts / painting)',
            description:
`I love ●●, and I enjoy it by &lt; watching at museum/theatre / creating myself / joining community events / etc... &gt;😊<br />
I've been into ●● since when I was &lt; ●● years old/ ●● th grade &gt;. My favorite &lt; actor / director / creator / artist / designer / etc... &gt; is ●●. My favorite work is ●●(work's name if any)🧡<br />
This photo is &lt; my favorite work/play called "●●" / a work of mine / from an event I've joined / etc...&gt;.<br />
Usually, I enjoy ●● &lt; on weekends / on weekdays evening / once a week / twice a month / etc... &gt;.　<br />
I wanna share my passion toward ●● with you❣️Please say hello to me📩<br />
Let's Paike out!😊`,
          },
        ],
      },
    }
  }),
  methods: {
    show(inputType) {
      if (this.display) {
        return
      }
      this.selectedTemplate = this.commentTemplates[inputType]
      this.comment = this.value
      this.display = true
    },
    endEdit() {
      this.display = false
      this.$emit('input', this.comment)
    },
    selectExample(i) {
      const selected = this.selectedTemplate.examples[i]
      this.selected.title = selected.title
      this.selected.description = selected.description
      this.selected.display = true
    },
    useExample(useType) {
      const description = this.selected.description.replace(/<br \/>/g, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
      if (useType == 'add') {
        this.comment += "\n" + description
      } else {
        this.comment = description
      }
      this.selected.display = false
      this.example.display = false
    }
  },
};
</script>
